import React from 'react';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';
import { Intl } from 'components';

export default ( { children, onSaveFavourite, id = 0 } ) => (
  <Row className="align-items-center mb-2">
    <Col>
      {children}
    </Col>
    <Col xs="auto" className="pl-0">
      <i
        className="fa text-lg cursor-pointer fa-save text-gray-7"
        onClick={onSaveFavourite}
        id={`saveFavouriteBtn-${id}`}
      />
      <UncontrolledTooltip
        delay={0}
        target={`saveFavouriteBtn-${id}`}
        offset="-30,8"
        className="campaign-wizard-tooltip"
      >
        <Intl id="saveToFavorites" />
      </UncontrolledTooltip>
    </Col>
  </Row>
);
